import { render, staticRenderFns } from "./questAssign.vue?vue&type=template&id=44085dc6&scoped=true"
import script from "./questAssign.vue?vue&type=script&lang=js"
export * from "./questAssign.vue?vue&type=script&lang=js"
import style0 from "./questAssign.vue?vue&type=style&index=0&id=44085dc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44085dc6",
  null
  
)

export default component.exports